export default __webpack_public_path__ + "static/media/imagen02.f5c88326.jpg";